import styled from "styled-components";

export const Wrapper = styled.div`
    display: grid;
    align-items: center;
    margin-bottom: 10px;
`;
export const TimeFieldsContainer = styled.div`
    display: flex;
    align-items: center;
`

export const TimeFieldWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    margin-left: 15px;
`

export const TimeFieldLabel = styled.span`
    color: #93939E;
    font-weight: 300;
`

export const ClosedLabel = styled.span`
    color: #93939E;
    font-weight: 300;
    min-height: 30px;
    width: 184px;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const Label = styled.div`
`;

export const Available = styled.div`
`;